/**
 * @generated SignedSource<<1c62161beb480517b8c118c6f29af2c8>>
 * @relayHash 7278d035f2d9d25ee8bb8b2c293f331d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec2cda5920826a1affcbdebcba18eeb94bba0add6283dc7079a42652ca91e500

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

import isJiraAiAgentAvatarCalendarViewEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-calendar-view.relayprovider';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ec2cda5920826a1affcbdebcba18eeb94bba0add6283dc7079a42652ca91e500",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarcalendarviewrelayprovider": isJiraAiAgentAvatarCalendarViewEnabled_provider
    }
  }
};

export default node;
